import Component from '../../../shared/component';

export default class MentionableTextarea extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.$textarea = $(
      `<textarea name="${this.$element.data('input-name')}"></textarea>`
    );

    this.addTextarea();
    this.bindEvents();
  }

  bindEvents() {
    this.onValueChange = this.onValueChange.bind(this);

    this.$element.on('updated.MentionableTextarea', this.onValueChange);

    this.$element.mentionsInput({
      elastic: false,
      triggerChar: '@',
      onDataRequest: (_mode, query, callback) =>
        this.handleDataRequest(query, callback),
    });
  }

  unbindEvents() {
    this.$element.off('updated.MentionableTextarea', this.onValueChange);

    this.$element.mentionsInput('destroy');
  }

  handleDataRequest(query, callback) {
    const autocompleteUrl = this.$element.data('autocomplete-url');

    $.ajax({url: autocompleteUrl, data: {q: query}}).done((data) =>
      this.handleAJAXSuccess(callback, data)
    );
  }

  handleAJAXSuccess(callback, data) {
    const users = data.mentionable_users.map((user) => {
      return {
        id: user.id,
        name: user.name,
        avatar: user.avatar_url,
        type: 'user',
      };
    });

    callback.call(this.$element, users);
  }

  addTextarea() {
    this.$textarea.insertAfter(this.$element);
    this.$textarea.hide();
  }

  onValueChange() {
    this.$element.mentionsInput('val', (data) =>
      this.updateTextareaValue(data)
    );
  }

  updateTextareaValue(data) {
    this.$textarea.html(data.replace('<script>', '').replace('</script>', ''));
  }
}
